import { Link } from "react-router-dom";

export function PoweredBy({ className = "", center = false }) {
  return (
    <div className={`font-mono text-[10px] text-zinc-600 ${center ? "text-center" : ""} ${className}`} data-testid="powered-by">
      Powered by{" "}
      <a href="https://cbkm.au" target="_blank" rel="noreferrer" className="hover:opacity-80 transition-opacity duration-75">
        <span className="cbkm-gold">CBKM</span><span className="text-zinc-500">.au</span>
      </a>
    </div>
  );
}

export function LegalLinks({ className = "" }) {
  return (
    <div className={`font-mono text-[10px] text-zinc-600 flex items-center gap-3 ${className}`}>
      <Link to="/privacy" className="hover:text-zinc-400 transition-colors duration-75" data-testid="link-privacy">Privacy</Link>
      <span className="text-zinc-800">·</span>
      <Link to="/terms" className="hover:text-zinc-400 transition-colors duration-75" data-testid="link-terms">Terms</Link>
    </div>
  );
}
